var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"basicinfo"},[_vm._v(" 升级会员页面 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }